export default class RangeFinder {
    constructor() {
        this.rangeName = '';

        this.init();
        this.prepareRangeTabs();
        this.bindEvents();
    }
    init() {
        const urls = document.querySelectorAll('section[data-block="header"] a[href*="/product-category/mattresses/"] + ul li');
        if (!urls.length) return;
        const pages = [];
        const pageNames = [];
        let rangeFinder = false;

        //populates the pages array with the hrefs of the range pages.
        urls.forEach(url => {
            if (url.textContent.trim().toLowerCase() === 'by range:') {
                rangeFinder = true;
                return; // Add a continue statement to skip to the next iteration
            }
            if (rangeFinder) {
                // Will check if the next sibling is null or if the next sibling has a class of pointer-events-none
                if ((!url.nextElementSibling || url.nextElementSibling.querySelector('a').classList.contains('pointer-events-none')) && url.querySelector('a')) {
                    pages.push(url.querySelector('a').href.trim().replace(window.location.origin, ''));
                    pageNames.push(url.textContent.trim());
                    rangeFinder = false;
                    return;
                }
                if (url.nextElementSibling && url.querySelector('a')) {
                    pages.push(url.querySelector('a').href.trim().replace(window.location.origin, ''));
                    pageNames.push(url.textContent.trim());
                }
            }
        });

        if (pages.includes(window.location.pathname) || window.location.pathname == '/product-category/mattresses/') {
            document.querySelector('#main').classList.add('js-range-product-category-page');
        }
    }

    //This will duplicate the wysiwyg content and add it under the tabs
    prepareRangeTabs() {
        const contents = document.querySelectorAll('.js-range-block .wysiwyg');
        if (!contents.length) return;

        contents.forEach((content, index) => {
            //creates a hidden wrapper for the wysiwyg content
            const div = document.createElement('div');

            //adds a specific class name so the tailwind styles can render.
            div.classList.add('range-tab-content');
            div.classList.add('hidden');

            //Will clone the original copy of the wysiwyg content and append it to the div
            const clone = content.cloneNode(true);
            div.appendChild(clone);

            //Will create a link between the tab and the content
            const container = content.closest('.js-range-block');
            if (!container) return;

            container.dataset.target = 'js-range-tab-content-' + index;
            div.dataset.source = 'js-range-tab-content-' + index;

            const parent = content.closest('.js-range-block-container');
            if (!parent) return;

            //Will add links to the div
            const link = parent.querySelector('a[href*="/product-category/"]');
            if (!link) {
                return;
            }

            div.insertAdjacentHTML(
                'beforeend',
                `
                <div>
                    <a href="${link.href}" class="js-view-details hidden no-underline btn btn--md btn--light-blue-outline mb-2">View Range</a>
                    <a href="#" class="js-close-details">Hide Details</a>
                </div>
            `
            );

            parent.parentElement.insertAdjacentElement('beforeend', div);
        });
    }

    bindEvents() {
        const buttons = document.querySelectorAll('.js-range-product-category-page .js-view-details');
        buttons.forEach(button => {
            button.classList.remove('hidden');

            button.addEventListener('click', e => {
                const rangeBlock = button.parentElement.querySelector('.js-range-block');
                if (!rangeBlock) return;

                document.querySelectorAll('.js-range-block').forEach(block => {
                    const parentEl = block.parentElement;
                    //Will close any other open tabs
                    if (parentEl.classList.contains('active')) {
                        parentEl.classList.remove('active');
                        const content = document.querySelector('.range-tab-content[data-source="' + block.dataset.target + '"]');
                        if (content) content.querySelector('.js-close-details').click();
                    }
                    parentEl.classList.add('not-active');
                });

                rangeBlock.parentElement.classList.add('active');
                rangeBlock.parentElement.classList.remove('not-active');

                if (window.innerWidth >= 768) return;
                e.preventDefault();
                button.classList.add('hidden');
                const contentBlock = document.querySelector('.range-tab-content[data-source="' + rangeBlock.dataset.target + '"]');
                if (!contentBlock) return;
                contentBlock.classList.remove('hidden');
            });
        });

        const closeButtons = document.querySelectorAll('.js-range-product-category-page .js-close-details');
        if (!closeButtons.length) return;

        closeButtons.forEach(button => {
            button.addEventListener('click', e => {
                e.preventDefault();
                const contentBlock = document.querySelector('.range-tab-content:not(.hidden)');
                if (!contentBlock) return;
                contentBlock.classList.add('hidden');

                const viewButton = document.querySelector('.js-range-block[data-target="' + contentBlock.dataset.source + '"]').parentElement.querySelector('.js-view-details');
                if (!viewButton) return;
                viewButton.classList.remove('hidden');

                document.querySelectorAll('.js-range-block-container.not-active').forEach(block => block.classList.remove('not-active'));
            });
        });
    }
}
new RangeFinder();
